if (!customElements.get('frame-option-selector-modal')) {
  class FrameOptionSelectorModal extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.backdrop = this.querySelector('.size-modal__backdrop');
      this.optionsContainer = this.querySelector('[data-frame-options]');
      this.querySelector('[data-close]')?.addEventListener('click', () => this.close());
      this.backdrop?.addEventListener('click', () => this.close());
      // Click anywhere outside the dialog content closes it. With showModal(), a click on
      // the native ::backdrop is dispatched with the <dialog> itself as the target.
      this.dialog?.addEventListener('click', (e) => {
        if (e.target === this.dialog) this.close();
      });
      this.dialog?.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') { e.preventDefault(); this.close(); }
      });
      // Photographic frame-side swatches, keyed by frame colour.
      this.frameImages = {
        black: this.dataset.frameImgBlack || '',
        white: this.dataset.frameImgWhite || '',
        naturel: this.dataset.frameImgNaturel || '',
      };
    }

    // Map a variant's frame colour to its frame-side photo. Anything that isn't
    // explicitly black or white (wood / natural / naturel) uses the naturel image.
    frameImageFor(frameColor) {
      const c = (frameColor || '').toLowerCase();
      if (c.indexOf('black') !== -1) return this.frameImages.black;
      if (c.indexOf('white') !== -1) return this.frameImages.white;
      return this.frameImages.naturel;
    }

    // options: [{ id, label, price, priceDiff, priceDiffFormatted, image, frameColor }]
    open(options, lineKey, properties, quantity) {
      this.lineKey = lineKey;
      this.properties = properties || {};
      this.quantity = quantity;
      this.renderOptions(options || []);
      this.dialog?.showModal();
      this.backdrop?.classList.add('active');
      document.body.style.overflow = 'hidden';
    }

    renderOptions(options) {
      if (!this.optionsContainer) return;
      this.optionsContainer.innerHTML = '';

      options.forEach((option) => {
        const card = document.createElement('button');
        card.type = 'button';
        card.className = 'frame-option-card';

        // Photographic frame-side swatch for this colour; fall back to the
        // variant mockup so a card never renders empty.
        const frameSrc = this.frameImageFor(option.frameColor);
        const previewSrc = frameSrc || option.image;
        if (previewSrc) {
          const img = document.createElement('img');
          img.className = 'frame-preview';
          img.src = previewSrc;
          img.alt = option.label || '';
          img.loading = 'lazy';
          // If the frame photo fails, fall back once to the variant mockup.
          img.addEventListener('error', () => {
            if (option.image && img.src !== option.image) {
              img.src = option.image;
            }
          });
          card.appendChild(img);
        }

        const label = document.createElement('span');
        label.className = 'frame-option-card__label';
        label.textContent = option.label || '';
        card.appendChild(label);

        if (option.priceDiff > 0 && option.priceDiffFormatted) {
          const price = document.createElement('span');
          price.className = 'frame-option-card__price';
          price.textContent = '+' + option.priceDiffFormatted;
          card.appendChild(price);
        }

        card.addEventListener('click', () => {
          this.close();
          window.performUpsell(this.lineKey, option.id, this.properties, this.quantity);
        });

        this.optionsContainer.appendChild(card);
      });
    }

    close() {
      this.dialog?.close();
      this.backdrop?.classList.remove('active');
      document.body.style.overflow = '';
    }
  }
  customElements.define('frame-option-selector-modal', FrameOptionSelectorModal);
}
